var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":"","id":"app"}},[_c('vue-extend-layouts'),_c('global')],1)}
var staticRenderFns = []

export { render, staticRenderFns }